
import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import {
  TabDefinition,
  TAB_CAP,
  isTabActive,
  resolveVisibleTabs
} from "@/utils/navigation";

@Component({
  name: "BottomTabBar"
})
export default class extends Vue {
  visibleTabs: TabDefinition[] = [];

  get workshopId() {
    return store.getters["user/workshopId"];
  }

  /**
   * Tabs shown in the bar. Anything past the cap is dropped -- those destinations remain
   * reachable from the sidebar, which is the only place they live on mobile now.
   */
  get barTabs(): TabDefinition[] {
    return this.visibleTabs.slice(0, TAB_CAP);
  }

  async created() {
    await this.loadTabs();
    // Claims are workshop scoped, so switching workshop can change who may see what.
    this.$watch("workshopId", () => this.loadTabs());
  }

  async loadTabs() {
    this.visibleTabs = await resolveVisibleTabs((this.$router as any).options.routes);
  }

  isActive(tab: TabDefinition): boolean {
    return isTabActive(tab, this.$route);
  }
}
